/**
 * Determines whether a FWG AlbumFolder should display the FWG-Only upsell banner.
 *
 * @param {Object} albumFolder The AlbumFolder.
 * @returns {boolean}
 */
export const shouldDisplayFWGOnlyUpsellBanner = albumFolder => {
  if (!albumFolder) {
    return false;
  }

  return !albumFolder.joins_enabled;
};

/**
 * Determines whether a FWG AlbumFolder should display the PF (onboarding) upsell banner.
 *
 * @param {Object} albumFolder The AlbumFolder.
 * @returns {boolean}
 */
export const shouldDisplayPFContentUpsellBanner = albumFolder => {
  if (!albumFolder || shouldDisplayFWGOnlyUpsellBanner(albumFolder)) {
    return false;
  }

  return albumFolder.joins_enabled;
};

/**
 * Determines whether a FWG AlbumFolder should display any of the upsell banners.
 *
 * @param {Object} albumFolder The AlbumFolder.
 * @returns {boolean}
 */
export const shouldDisplayUpsellBanner = albumFolder => {
  if (!albumFolder) {
    return false;
  }

  return (
    shouldDisplayFWGOnlyUpsellBanner(albumFolder) ||
    shouldDisplayPFContentUpsellBanner(albumFolder)
  );
};
